import { ref } from 'vue'

export const quantityBus = ref<number>(1)
